import React from 'react';
import externalService from '../../service/external';
import { facebookPopup, twitterPopup } from '../../util/share';
import getArticleLink from '../../util/getArticleLink';
import { appContext } from '../../util/decorators';
import TotalShares from './TotalShares.jsx';
import ShareButton from '../ShareButton.jsx';
import Mail from '../Mail.jsx';

@appContext
export default class ArticleShare extends React.PureComponent {
  static propTypes = {
    contentContainer: React.PropTypes.object.isRequired,
  };

  render() {
    const url = getArticleLink(this.props.contentContainer, { href: true });
    return (
      <div className="article-share">
        <h2 className="structural">{this.context.app.t('ArticleShare.share_article')}</h2>
        <div className="share-buttons">
          <TotalShares url={url} />
          <ShareButton
            type="facebook"
            url={url}
            title={this.props.contentContainer.title}
            getCount={() => externalService.getFacebookCount(url).then(res => res.share_count)}
            popup={facebookPopup}
          />
          <ShareButton
            type="twitter"
            url={url}
            title={this.props.contentContainer.title}
            getCount={externalService.getTwitterCount}
            popup={twitterPopup}
          />
          <Mail url={url} title={this.props.contentContainer.title} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/ArticleShare.jsx